import AddIcon from '@mui/icons-material/Add';
import { SxStyle } from '../../../../types';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useStringsContext } from '../../../../contexts/strings';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Button, Grid2 } from '@mui/material';
import SceneHeader from '../../../common/scene/scene-header';

const styles: SxStyle = {
  seasonSelect: {
    width: '250px',
  },
};

interface Props {
  season: string;
  onAddMember: () => void;
  onSelectSeason: (value: string) => void;
  onUploadImages: () => void;
}

const { REACT_APP_DEFAULT_LEAGUE_SEASON } = process.env;
const CURRENT_YEAR = parseInt(REACT_APP_DEFAULT_LEAGUE_SEASON as string, 10);
const SEASONS = Array.from(Array(0).keys()).map((i) => (CURRENT_YEAR - i).toString());

function StaffOverviewHeader({ season, onAddMember, onSelectSeason, onUploadImages }: Props) {
  const { strings } = useStringsContext();

  return (
    <SceneHeader title={strings.appBar.staff}>
      <Grid2>
        <Autocomplete
          size="small"
          disableClearable
          options={SEASONS}
          sx={styles.seasonSelect}
          value={season}
          onChange={(event, value) => onSelectSeason(value)}
          renderInput={(params) => <TextField {...params} label={strings.squad.season} />}
        />
      </Grid2>
      <Grid2 size="grow" />
      <Grid2 container spacing={2}>
        <Grid2>
          <Button
            variant="contained"
            onClick={() => onUploadImages()}
            startIcon={<CloudUploadIcon />}
          >
            {strings.staff.uploadImages}
          </Button>
        </Grid2>
        <Grid2>
          <Button variant="contained" onClick={() => onAddMember()} startIcon={<AddIcon />}>
            {strings.staff.addMember}
          </Button>
        </Grid2>
      </Grid2>
    </SceneHeader>
  );
}

export default StaffOverviewHeader;
